'use client';

import { useLeadTracking } from '@varsitytutors/lead-tracking';

interface MetaPixelLoaderProps {
  loadDelay?: number;
  pixelId: string;
}

export function MetaPixelLoader({ loadDelay, pixelId }: MetaPixelLoaderProps) {
  useLeadTracking({ pixelId, pixelLoadDelay: loadDelay });
  return null;
}

export default MetaPixelLoader;
